<template>
    <v-dialog v-model="visible" max-width="1200px">
        <JobCategorySearchContent :comId="comId">
            <template v-slot:close>
                <v-toolbar color="#f9f9f9" flat>
                    <v-toolbar-title>选择职业类别</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon @click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
            </template>
        </JobCategorySearchContent>
    </v-dialog>
</template>

<script>
    import JobCategorySearchContent from "@/components/Order/JobCategorySearchContent";
    export default {
        components: {
            JobCategorySearchContent
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            comId:{
                type:String,
                default:'1001'
            },
            // 职业类别限制到几级
            limit: Number,
        },
        data(){
            return {
            }
        },
        computed: {
            visible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit("input", v);
                }
            }
        },
        mounted() {
        },
        methods:{
            close() {
                this.visible = false;
            }
        }
    }
</script>

<style scoped>

</style>
